import { selectIcon, colorSelector } from "../components/UI/selector";
import {
  convertMinute,
  convertMinutes,
  CheckValue,
  checkRole,
  sortData,
  sortOrder,
  sortOrder1,
  addMinute,
  todayDate,
  convertMinutes1,
  isBoolean,
} from "./CommonFunction";
import {
  billing_frequency,
  currency,
  paymentTypeOption,
  staticVar,
  transactionStaus,
} from "./Constants";
import { userData } from "./subscriberService";
import moment from "moment";
import {
  getEquipment,
  StaffSort,
} from "../containers/ActivityList/ActivityService";
import { nanoid } from "@reduxjs/toolkit";
import { mediaArr } from "../containers/ActivityList/ClassForm/CommonClassFunc";

const setDate = (date) => {
  if (date) {
    return moment(date).add(new Date(date).getTimezoneOffset(), "minutes");
  }
  return null;
};

export const setCoach = (el) => ({
  name: el.first_name + " " + el.last_name,
  first_name: el.first_name,
  last_name: el.last_name,
  id: el.user_id,
  keyValue: "id",
  thumb: el.profile_pic_thumb || selectIcon("userDummy"),
  original: el.profile_pic_original || selectIcon("userDummy"),
});
export const setMember = (el) => ({
  name: el.first_name + " " + el.last_name,
  first_name: el.first_name,
  last_name: el.last_name,
  id: el.user_id,
  keyValue: "id",
  thumb: el.profile_pic_thumb || selectIcon("userDummy"),
  original: el.profile_pic_original || selectIcon("userDummy"),
});

export const setListCoach = (el) => {
  const data = {
    name: `${el.first_name || ""} ${el.last_name || ""}`,
    first_name: el.first_name,
    last_name: el.last_name,
    email: el.email || "",
    age: el.age || 0,
    dob: el.dob,
    deletion_requested_at: el.deletion_requested_at,
    is_permanently_deleted: el.is_permanently_deleted,
    showAction: userData.detail.user_id !== el.user_id,
    date: setDate(el.updated_at),
    requestedOn: setDate(el.updated_at),
    thumb: el.profile_pic_thumb || selectIcon("userDummy"),
    addedOn: setDate(el.approved_at || el.created_at),
    original: el.profile_pic_original || selectIcon("userDummy"),
    description: el.description || null,
    stripe_customer_id: el.stripe_customer_id || null,
    specialisations: el.specialisations || [],
    id: el.user_id || null,
    keyValue: "id",
    location: el.location_details || [],
    reason: {
      remove: el.removal_comment || null,
      reject: el.rejection_comment || null,
    },
    completeActivity: el.number_of_activities_done || 0,
    number_of_calories_burnt: el.number_of_calories_burnt || 0,
    scheduleActivity: 0,
    is_gym_link_request_via_link: el.is_gym_link_request_via_link || false,
  };
  return data;
};

export const setRoom = (el) => ({
  name: el.name === null ? "Activity Room" : el.name ? el.name : "",
  clone: el.name === null,
  id: el.room_id || null,
  keyValue: "id",
  gym_id: el.gym_id || "--",
  created_at: el.created_at || "--",
  is_deleted: el.is_deleted || "--",
  updated_at: el.updated_at || "--",
  activities_done: el.activities_done || "0",
});

export const setMTClassType = (el) => ({
  name: el.attributes === null ? "" : el.attributes.name || "",
  id: el.id || null,
  keyValue: "name",
  type: el.type || "",
});

export const setLocation = (el) => ({
  name: el.location_name || "",
  id: el.location_id || null,
  keyValue: "id",
  is_active: el.is_active,
  is_default_location: el.is_default_location || false,
});

export const setTransaction = (el) => ({
  interval:
    el.lines &&
    el.lines.data &&
    el.lines.data.length &&
    el.lines.data.plan &&
    el.lines.data.plan.interval
      ? el.lines.data[0].plan.interval
      : "",
  created: el.created ? el.created * 1000 : "---",
  number: el.number || "---",
  amount_paid: el.amount_paid || 0,
  hosted_invoice_url: el.hosted_invoice_url || "",
  cardDetail: el.metadata ? `${el.metadata.brand} ${el.metadata.last4}` : "--",
  id: el.id,
  keyValue: "id",
});

export const defaultSetGym = () => {
  const data = {
    name: "- -",
    first_name: "-",
    last_name: "-",
    email: "---",
    linked_role: "",
    roles: [],
    coach_profile_step: null,
    addedByName: ``,
    addedByFirstName: "",
    linked_status: 0,
    age: 0,
    dob: "---",
    is_published: false,
    date: null,
    requestedOn: null,
    addedOn: null,
    thumb: selectIcon("userDummy"),
    original: selectIcon("userDummy"),
    id: null,
    value: null,
    keyValue: "id",
    membership_code: "",
  };
  return data;
};
export const setGym = (el) => {
  const data = {
    name: el.gym_name
      ? el.gym_name
      : el.name || `${el.first_name || "-"} ${el.last_name || "-"}`,
    first_name: el.first_name || el.name || "-",
    last_name: el.last_name || "-",
    email: el.email || "---",
    linked_role: el.linked_role || "",
    roles: el.roles,
    coach_profile_step: el.coach_profile_step || null,
    addedByName: `${el.added_by_user_first_name || ""} ${
      el.added_by_user_last_name || ""
    }`,
    addedByFirstName: el.added_by_user_first_name || "",
    linked_status: el.linked_status || 0,
    age: el.age || 0,
    dob: el.dob || "---",
    is_published: el.linked_status === 1 || el.linked_status === 4,
    date: setDate(el.updated_at),
    requestedOn: setDate(el.updated_at),
    addedOn: setDate(el.approved_at),
    thumb: el.profile_pic_thumb || el.logo_thumb || selectIcon("userDummy"),
    original:
      el.profile_pic_original || el.logo_original || selectIcon("userDummy"),
    id: el.gym_id || null,
    value: el.gym_id || null,
    keyValue: "id",
    membership_code: el.membership_code || "",
  };
  return data;
};
export const setGymUser = (el) => {
  const data = {
    name: el.name || `${el.first_name || "-"} ${el.last_name || "-"}`,
    first_name: el.first_name || el.name || "-",
    last_name: el.last_name || "-",
    email: el.email || "---",
    linked_role: el.linked_role || "",
    roles: el.roles,
    coach_profile_step: el.coach_profile_step || null,
    addedByName: `${el.added_by_user_first_name || ""} ${
      el.added_by_user_last_name || ""
    }`,
    addedByFirstName: el.added_by_user_first_name || "",
    linked_status: el.linked_status || 0,
    age: el.age || 0,
    dob: el.dob || "---",
    is_published: el.linked_status === 1 || el.linked_status === 4,
    date: setDate(el.updated_at),
    requestedOn: setDate(el.updated_at),
    addedOn: setDate(el.approved_at),
    thumb: el.profile_pic_thumb || selectIcon("userDummy"),
    original: el.profile_pic_original || selectIcon("userDummy"),
    id: el.gym_id || null,
    value: el.gym_id || null,
    keyValue: "id",
    membership_code: el.membership_code || "",
  };
  return data;
};

export const setActivityLogos = (el) => ({
  name: el.Key || "",
  id: el.activity_logo_original || el.url || "",
  keyValue: "id",
  thumb: el.activity_logo_thumb || el.url || selectIcon("activityImage"),
  original:
    el.activity_logo_original ||
    el.activity_logo_thumb ||
    el.url ||
    selectIcon("activityImage"),
});
export const setClassPortraitImage = (el) => ({
  name: el.Key || "",
  id: el.activity_logo_portrait_original || null,
  keyValue: "id",
  thumb: el.activity_logo_portrait_thumb || selectIcon("activityImage"),
  original:
    el.activity_logo_portrait_original ||
    el.activity_logo_portrait_thumb ||
    selectIcon("activityImage"),
});

const filterImage = (image) => {
  if (CheckValue(image) && image.length) {
    let setImage = {};
    image.forEach((el) => {
      if (CheckValue(setImage[el.id])) {
        if (el.original !== "") {
          setImage[el.id].original = el.original;
        } else {
          setImage[el.id].thumbnail = el.thumbnail;
        }
      } else {
        setImage[el.id] = { ...el };
      }
    });
    let newImage = Object.values(setImage).filter(
      (res) => res.original !== "" && res.thumbnail !== ""
    );
    if (newImage.length > 5) {
      newImage = newImage.slice(0, 5);
    }
    return newImage;
  } else {
    return [];
  }
};

export const setActivity = (el) => {
  try {
    const activity_lanscape_images = filterImage(el.activity_lanscape_images);
    const activity_portrait_images = filterImage(el.activity_portrait_images);
    const activity_square_images = filterImage(el.activity_square_images);
    return {
      id: el.activity_id,
      title: el.name || "",
      progress: 0,
      downloadStatus: "pending",
      used_media_ids: el.used_media_ids || [],
      activity_lanscape_images: activity_lanscape_images,
      activity_portrait_images: activity_portrait_images,
      activity_square_images: activity_square_images,
      users_in_live_activity: el.users_in_live_activity || 0,
      activityType:
        el.activity_categories && el.activity_categories.length
          ? el.activity_categories.map((el) => setDropdownCategory(el))
          : [],
      tags: el.tags || [],
      created_at: el.started_at,
      live_recording_status: el.live_recording_status,
      ondemandVideoStatus: el.ondemand_video_conversion_is_inprogress || false,
      duration: el.duration_in_minutes
        ? convertMinute(el.duration_in_minutes)
        : null,
      durations: el.duration_in_minutes
        ? convertMinutes(el.duration_in_minutes)
        : null,
      duration_in_seconds:
        el.duration_in_seconds ||
        (el.duration_in_minutes ? convertMinutes(el.duration_in_minutes) : 0),
      time: el.started_at,
      playback_url: el.ondemand_video_conversion_is_inprogress
        ? el.playback_url
        : el.playback_url ||
          (el.ondemand_videos && el.ondemand_videos.length
            ? el.ondemand_videos[el.ondemand_videos.length - 1]
            : null),
      is_published: el.is_published,
      privacy_settings: el.privacy_setting || null,
      gym: setGym(el),
      completeActivity: el.total_attempts || 0,
      calloriesBurn: Math.round(el.avg_calories_burnt || 0),
      heratRate: Math.round(el.avg_of_max_heart_rate_percent || 0),
      group: el.users_in_activity || 0,
      status: el.ondemand_videos ? "both" : el.playback_url ? "vod" : "live",
      download:
        el.mp4_recording && CheckValue(el.mp4_recording)
          ? el.mp4_recording
          : false,
      location: el.location_details ? el.location_details : [],
      leaderboard_type: CheckValue(el.leaderboard_type)
        ? el.leaderboard_type
        : true,
      heartrate_required: CheckValue(el.heartrate_required)
        ? el.heartrate_required
        : true,
      activityLogo: setActivityLogos(el),
      image: setActivityLogos(el),
      imagePortrait: setClassPortraitImage(el),
      template: setTemplate({ ...el, is_published: true }),
    };
  } catch (error) {
    console.error(error);
  }
};

const ExtractContent = (s) => {
  var span = document.createElement("span");
  span.innerHTML = s;
  return span.textContent || span.innerText;
};

export const setScheduleActivity = (el) => {
  const duration_in_seconds =
    el.duration_in_seconds ||
    (el.duration_in_minutes ? el.duration_in_minutes * 60 : 0);
  return {
    id: el.activity_id,
    parent_id: el.parent_activity_id,
    action: false,
    title: el.name || "",
    countMe: el.activity_booking_count || 0,
    addon_id: el.addon_id || 0,
    used_media_ids: el.used_media_ids || [],
    activityType:
      el.activity_categories && el.activity_categories.length
        ? el.activity_categories.map((el) => setDropdownCategory(el))
        : [],
    start_datetime: el.start_datetime || new Date(),
    end_datetime: el.end_datetime || new Date(),
    repeat_on_week_days: el.repeat_on_week_days || [],
    schedule_type: el.schedule_type || staticVar.oneDay,
    roomName: el.workout_room_name || undefined,
    activitySetup: el.activity_setup || undefined,
    created_at: el.started_at,
    low_latency_mode: el.low_latency_mode || "false",
    mute_participants_by_default: el.mute_participants_by_default || "false",
    ondemandVideoStatus: el.ondemand_video_conversion_is_inprogress || false,
    durationSecond: duration_in_seconds,
    duration: el.duration_in_minutes
      ? convertMinute(el.duration_in_minutes)
      : null,
    durations: el.duration_in_minutes
      ? convertMinutes(el.duration_in_minutes, "minute")
      : null,
    time: el.started_at,
    playback_url: el.ondemand_video_conversion_is_inprogress
      ? el.playback_url
      : el.playback_url ||
        (el.ondemand_videos && el.ondemand_videos.length
          ? el.ondemand_videos[el.ondemand_videos.length - 1]
          : null),
    is_published: el.is_published,
    platform:
      el.mb_class_id === null && el.mt_class_id === null
        ? staticVar.tribe
        : el.mb_class_id === null
        ? staticVar.marianatek
        : staticVar.mindbody,
    mt_class_id: el.mt_class_id ? el.mt_class_id.toString() : el.mt_class_id,
    mb_class_id: el.mb_class_id ? el.mb_class_id.toString() : el.mb_class_id,
    class_recurring_id: el.class_recurring_id,
    gym: setGym(el.gym_id ? el : userData.selectedGym),
    status: el.is_published || false,
    activity_status: el.activity_status || undefined,
    completeActivity: el.total_attempts || 0,
    deepLink: el.activity_link || undefined,
    openWaitingRoom: false,
    make_ondemand: CheckValue(el.make_ondemand) ? el.make_ondemand : undefined,
    privacy_settings: el.privacy_setting || undefined,
    activity_password: el.activity_password || undefined,
    participant_video_visibility: el.participant_video_visibility_in_attempt,
    tags: el.tags || [],
    template: setTemplate({ ...el, is_published: true }),
    imagePortrait: setClassPortraitImage(el),
    activityLogo: setActivityLogos(el),
    location: el.location_details
      ? el.location_details.map((el) => setLocation(el)).sort(sortData)
      : [],
  };
};

export const setStaff = (el, role) => ({
  first_name: el.first_name,
  last_name: el.last_name,
  name: el.first_name + " " + el.last_name,
  profile_pic_original: el.profile_pic_original,
  profile_pic_thumb: el.profile_pic_thumb,
  roles: checkRole("gym", role) ? "owner" : "coach",
  socket_id: [el.socket_id],
  user_id: el.user_id,
});

const setClassCoach = (data) => ({
  first_name: data.first_name,
  last_name: data.last_name,
  created_by: data.created_by,
  user_id: data.created_by,
  isVideoStarted: false,
  stream: false,
  profile_pic_thumb: data.profile_pic_thumb,
  waitingRoom_open_by: data.waiting_room_opened_by,
  host: userData.detail.user_id === data.created_by,
  ownerHost:
    userData.detail.user_id === data.created_by
      ? false
      : data.waiting_room_opened_by === userData.detail.user_id,
  mainHost: userData.detail.user_id === data.created_by,
  ownerVideoStarted: false,
  ownerStream: false,
});

export const activeActivity = (res) => {
  let temp2 = {};
  let temp3 = {};
  if (res.staffsInActivity) {
    let staffsInActivity = {};
    let staffsInActivity1 = {};
    res.staffsInActivity.forEach((el) => {
      let role = typeof el.roles === "string" ? [el.roles] : el.roles;
      if (userData.detail.user_id === el.user_id || checkRole("gym", role)) {
        if (CheckValue(staffsInActivity[el.user_id])) {
          staffsInActivity1[el.user_id].socket_id.push(el.socket_id);
          staffsInActivity1[el.user_id].socket_id = StaffSort(
            staffsInActivity[el.user_id].socket_id
          );
        } else {
          staffsInActivity1[el.user_id] = setStaff(el, role);
        }
      } else {
        if (CheckValue(staffsInActivity[el.user_id])) {
          staffsInActivity[el.user_id].socket_id.push(el.socket_id);
          staffsInActivity[el.user_id].socket_id = StaffSort(
            staffsInActivity[el.user_id].socket_id
          );
        } else {
          staffsInActivity[el.user_id] = setStaff(el, role);
        }
      }
    });
    temp2.staffsInActivity = staffsInActivity;
    temp3.staffsInActivity = staffsInActivity1;
  }
  const mainHost =
    res.created_by === userData.detail.user_id ||
    (res.waiting_room_opened_by === userData.detail.user_id &&
      !CheckValue(temp2.staffsInActivity[res.created_by]))
      ? true
      : false;
  let host = false;
  if (mainHost && CheckValue(localStorage.getItem("host"))) {
    host = true;
  }

  let temps = 0;
  if (CheckValue(res.workout_builder) && res.workout_builder.length) {
    res.workout_builder.sort(sortOrder1);
    res.workout_builder.forEach((el, index1, arr) => {
      temps += index1 === 0 ? 0 : arr[index1 - 1].segment_duration_in_seconds;
      let temp = 0;
      let temp1 = temps;
      el.exercises.sort(sortOrder);
      el.exercises.forEach((el1, index) => {
        temp = temp1;
        temp1 += el1.exercise_duration_in_seconds;
        el1.min = temp;
        el1.max = temp1;

        mediaArr().forEach((res) => {
          let keyName = `exercise_${res}`;
          if (CheckValue(el1[keyName])) {
            let exerciseData = el1[keyName];
            if (!Array.isArray(el1[keyName]) || el1[keyName].length) {
              if (Array.isArray(el1[keyName])) {
                exerciseData = el1[keyName][0];
              }
              const playAt = temp + exerciseData[`${res}_play_at`];
              const playDuration =
                playAt + exerciseData[`${res}_play_duration`];
              exerciseData.min = playAt;
              exerciseData.max = playDuration;
              if (!CheckValue(exerciseData.media_id)) {
                exerciseData.media_id = nanoid();
              }
              // el1[keyName] = exerciseData;
            }
          }
        });
      });
      el.min = temps;
    });
  }
  // const host = CheckValue(localStorage.getItem('openByme'));
  return {
    staffsInActivity: {
      ...temp2.staffsInActivity,
      ...temp3.staffsInActivity,
    },
    gymData: {
      name: res.gym_name,
      logo: res.logo_thumb,
      id: res.gym_id,
    },
    coachData: setClassCoach(res),
    myStatus: res.created_by === userData.detail.user_id,
    activity_types:
      CheckValue(res.activity_types) && res.activity_types.length
        ? res.activity_types[0]
        : "",
    coach_notes: res.coachNotes || "",
    low_latency_mode: res.low_latency_mode || false,
    mute_participants_by_default: res.mute_participants_by_default || false,
    activity_description: res.description || "",
    equipments_required: res.equipments_required || [],
    activity_name: res.name || "",
    activity_setup: res.activity_setup || "",
    activity_id: res.activity_id || "",
    activity_status: res.activity_status || "",
    status: res.activity_status || "",
    activityLogo: setActivityLogos(res),
    created_by: res.created_by || null,
    created_at: res.created_at || null,
    started_at: res.started_at || null,
    started_by: res.started_by || null,
    waitngRoom_open_by: res.waiting_room_opened_by || null,
    host: host,
    mainHost: mainHost,
    beforehost: host
      ? res.created_by === userData.detail.user_id
        ? CheckValue(temp3.staffsInActivity[res.created_by])
        : CheckValue(temp3.staffsInActivity[res.waiting_room_opened_by])
      : false,
    ended_at: res.ended_at || null,
    duration_in_second: convertMinutes1(res.duration_in_minutes),
    heartrate_required: CheckValue(res.heartrate_required)
      ? res.heartrate_required
      : true,
    leaderboard_type: CheckValue(res.leaderboard_type)
      ? res.leaderboard_type
      : true,
    streaming_started_by: res.streaming_started_by || null,
    streaming_ended_by: res.streaming_ended_by || null,
    started_time: new Date(res.start_datetime).getTime(),
    start_datetime: res.start_datetime || null,
    end_datetime: res.end_datetime || null,
    // activity_logo_thumb: res.activity_logo_thumb,
    // activity_logo_original: res.activity_logo_original,
    streaming: res.stream_key === null ? false : true,
    streamUrl: res.input_rtmp_url || "",
    stream_key: res.stream_key || "",
    totalSeconds:
      res.started_at !== null
        ? Math.round(
            (new Date().getTime() - new Date(res.started_at).getTime()) / 1000
          )
        : 0,
    previousSeconds:
      res.start_datetime !== null
        ? Math.round(
            (new Date(res.start_datetime).getTime() - new Date().getTime()) /
              1000
          )
        : 0,
    usersInActivity: res.usersInActivity
      ? res.usersInActivity
          .filter((el) => !res.booted_out_users.includes(el.user_id))
          .map((element, index) =>
            setUserForActiveActivity(element, index, res.activity_id)
          )
      : [],
    workout_builder: res.workout_builder || [],
    playback_url: res.playback_url || null,
    video_conference_data: res.video_conference_object
      ? { ...res.video_conference_object }
      : null,
    average: {
      min_calories_burnt: checkCondition(
        res.current_class_stats,
        "min_calories_burnt"
      ),
      max_calories_burnt: checkCondition(
        res.current_class_stats,
        "max_calories_burnt"
      ),
      avg_calories_burnt: checkCondition(
        res.current_class_stats,
        "avg_calories_burnt"
      ),
      min_of_max_heart_rate_percent: checkCondition(
        res.current_class_stats,
        "min_of_max_heart_rate_percent"
      ),
      max_of_max_heart_rate_percent: checkCondition(
        res.current_class_stats,
        "max_of_max_heart_rate_percent"
      ),
      avg_of_max_heart_rate_percent: checkCondition(
        res.current_class_stats,
        "avg_of_max_heart_rate_percent"
      ),
    },
  };
};

const checkCondition = (data, status) =>
  data && CheckValue(data[status]) ? Math.round(data[status]) : "- - -";

export const setUserForActiveActivity = (element, index, activity_id) => {
  let data = {
    ...element,
    rank: index + 1,
    name: element.first_name + " " + element.last_name,
    activity_id: activity_id,
    isVideoStarted: false,
    max_heart_rate_percent: Math.round(
      element["avg_of_max_heart_rate_percent"] || 0
    ),
    calories_burnt: Math.round(element["calories_burnt"] || 0),
    participant_video_visibility:
      element.participant_video_visibility_in_attempt,
  };
  if (data.user_status_in_activity === staticVar.ended) {
    data["color"] = colorSelector();
    data["opacity"] = "0.6";
    data["isRemoved"] = true;
  } else if (data.user_status_in_activity === staticVar.roomStarted) {
    data["color"] = colorSelector(
      Math.round(data["avg_of_max_heart_rate_percent"] || 0)
    );
    data["opacity"] = "unset";
    data["isRemoved"] = false;
  } else if (data.user_status_in_activity === staticVar.waiting) {
    data["color"] = colorSelector();
    data["opacity"] = "unset";
    data["isRemoved"] = false;
  }
  data["muted"] = true;
  // data['avg_of_max_heart_rate_percent'] = 65;
  return data;
};

export const setCount = (count) => {
  if (count) {
    return count ? parseInt(count[0].count, 10) : 0;
  }
  return null;
};

export const setMemberSummaryData = (el) => {
  const memberData = { ...JSON.parse(localStorage.getItem("memberData")) };
  return {
    name: el.name || "--",
    rank: el.rank || "--",
    memberData: memberData || {},
    age: memberData.age || 0,
    user_activity_session_id: el.user_activity_session_id || "--",
    started_at: el.started_at ? el.started_at : el.ended_at,
    ended_at: el.ended_at ? el.ended_at : el.started_at,
    activity_logo_thumb: el.activity_logo_thumb || "",
    orange_theory_graph: el.orange_theory_graph ? el.orange_theory_graph : {},
    graphData:
      el.heart_rate_graph !== null && el.heart_rate_graph.length
        ? [...el.heart_rate_graph]
        : [],
    calories_burnt: Math.round(el.calories_burnt || 0),
    duration_in_minutes: Math.round(el.duration_in_minutes || 0),
    duration_in_minute: convertMinute(el.duration_in_minutes),
    avg_of_max_heart_rate_percent: Math.round(
      el.avg_of_max_heart_rate_percent || 0
    ),
    max_of_max_heart_rate_percent: Math.round(
      el.max_of_max_heart_rate_percent || 0
    ),
    min_of_max_heart_rate_percent: Math.round(
      el.min_of_max_heart_rate_percent || 0
    ),
    leaderBoard: CheckValue(el.leaderboard_type) ? el.leaderboard_type : true,
    heartRate: CheckValue(el.heartrate_required) ? el.heartrate_required : true,
  };
};

export const defaultsetTemplate = (el) => {
  return {
    templateId: "",
    duration: 0,
    keyValue: "templateId",
    name: "",
    title: "",
    activityType: [],
    difficultyLevel: "",
    description: "",
    coachNotes: "",
    private_hint: "",
    equipments: [],
    requiredEquipment: [],
    optionalEquipment: [],
    workout_builder: [],
    tagList: [],
    tags: [],
    shared: false,
    coach: null,
    used_media_ids: [],
    created_by: "",
    is_published: false,
    leaderboard_type: true,
    heartrate_required: true,
    created_at: null,
    updated_at: null,
    last_used_at: null,
  };
};
export const setTemplate = (el) => {
  let temp = null;
  let temps = 0;
  if (CheckValue(el.workout_builder) && el.workout_builder.length) {
    el.workout_builder.sort(sortOrder1);
    el.workout_builder.forEach((el2, index1, arr) => {
      temps += index1 === 0 ? 0 : arr[index1 - 1].segment_duration_in_seconds;
      let temp = 0;
      let temp1 = temps;
      el2.exercises = el2.exercises.filter((el1) => CheckValue(el1));
      el2.exercises.sort(sortOrder);
      el2.exercises.forEach((el1, index) => {
        if (CheckValue(el1)) {
          temp = temp1;
          temp1 += el1.exercise_duration_in_seconds;
          el1.min = temp;
          el1.max = temp1;
          mediaArr().forEach((res) => {
            let keyName = `exercise_${res}`;
            if (CheckValue(el1[keyName])) {
              let exerciseData = {};
              if (Array.isArray(el1[keyName])) {
                if (el1[keyName].length) {
                  exerciseData = { ...el1[keyName][0] };
                }
              } else {
                exerciseData = { ...el1[keyName] };
              }
              if (Object.keys(exerciseData).length) {
                const playAt = temp + exerciseData[`${res}_play_at`];
                const playDuration =
                  playAt + exerciseData[`${res}_play_duration`];
                exerciseData.min = playAt;
                exerciseData.max = playDuration;
                if (!CheckValue(exerciseData.media_id)) {
                  exerciseData.media_id = nanoid();
                }
              }
            } else {
              delete el1[keyName];
            }
          });
        }
      });
      el2.min = temps;
    });
  }
  return {
    templateId: el.class_template_id || "",
    duration:
      el.duration_in_ms && el.duration_in_ms > 0 ? el.duration_in_ms / 1000 : 0,
    keyValue: "templateId",
    name: el.template_name || "",
    title: el.template_name || "",
    activityType:
      el.activity_categories && el.activity_categories.length
        ? el.activity_categories.map((el) => setDropdownCategory(el))
        : [],
    difficultyLevel: CheckValue(el.difficulty_level)
      ? el.difficulty_level
      : "NOT_AVAILABLE",
    description: CheckValue(el.description)
      ? ExtractContent(el.description)
      : "",
    coachNotes: CheckValue(el.coachNotes || el.coach_notes)
      ? el.coachNotes || el.coach_notes
      : "",
    private_hint: CheckValue(el.private_hint) ? el.private_hint : "",
    equipments: el.equipments_required || [],
    requiredEquipment: getEquipment(el.equipments_required, true),
    optionalEquipment: getEquipment(el.equipments_required, false),
    workout_builder: el.workout_builder || [],
    tagList: temp || [],
    tags: el.tags || [],
    shared: el.is_template_shared || false,
    coach:
      el.created_by !== null
        ? setCoach({ ...el, user_id: el.created_by })
        : null,
    used_media_ids: el.used_media_ids,
    created_by: el.created_by || "",
    is_published: el.is_published || false,
    leaderboard_type: CheckValue(el.leaderboard_type)
      ? el.leaderboard_type
      : true,
    heartrate_required: CheckValue(el.heartrate_required)
      ? el.heartrate_required
      : true,
    created_at: el.created_at || null,
    updated_at: el.updated_at || null,
    last_used_at: el.last_used_at || null,
  };
};

export const SetMediaClip = (el) => {
  return {
    media_id: el.media_id || "",
    media_name: (el.media_name || "").trim(),
    tags: el.tags || [],
    original: el.image_url_original || null,
    thumbnail: el.image_url_thumb || null,
    audio_url: el.audio_url || null,
    video_url: el.video_url || null,
    media_upload_is_inprogress: CheckValue(el.media_upload_is_inprogress)
      ? el.media_upload_is_inprogress
      : true,
    error:
      (!CheckValue(el.is_media_upload_from_panel_completed) &&
        !CheckValue(el.image_url_thumb) &&
        !CheckValue(el.audio_url) &&
        !CheckValue(el.video_url)) ||
      !el.is_media_upload_from_panel_completed
        ? addMinute(30, new Date(el.created_at)) < +todayDate()
        : false,
    duration_in_ms: el.duration_in_ms || 0,
    mediaType: el.media_type,
    coach: setCoach(
      el.first_name
        ? { ...el, user_id: el.media_added_by }
        : { ...userData.detail }
    ),
  };
};

export const SetCategoryData = (el) => ({
  keyValue: "category_id",
  category_id: el.category_id || "",
  category_name: el.category_name || "",
  category_position: el.category_position,
  tags: el.tags || [],
  category_image_original: el.category_image_original || null,
  category_image_thumb: el.category_image_thumb || null,
  is_featured: el.is_featured || false,
  is_published: el.is_published || false,
  is_icon_selected: el.is_icon_selected || false,
});

export const SetClassByCategory = (el) => ({
  keyValue: "media_id",
  media_id: el.activity_id || "",
  activity_categories:
    el.activity_categories && el.activity_categories.length
      ? el.activity_categories.map((el) => setDropdownCategory(el))
      : [],
  duration_in_seconds: el.duration_in_minutes
    ? convertMinutes(el.duration_in_minutes)
    : 0,
  video_url:
    el.playback_url ||
    (el.ondemand_videos.length ? el.ondemand_videos[0] : null),
  playback_url: el.playback_url || null,
  activity_logo_thumb: el.activity_logo_thumb || null,
  activity_logo_original: el.activity_logo_original || null,
  media_name: el.name || "",
  ondemand_videos: el.ondemand_videos || null,
  make_ondemand: el.make_ondemand || false,
  difficulty_level: el.difficulty_level || null,
  mp4_recording: el.mp4_recording || null,
});

export const setDropdownCategory = (el) => ({
  name: el.category_name,
  id: el.category_id,
  keyValue: "id",
  isFeature: el.is_featured || false,
  thumb: el.category_image_thumb || selectIcon("userDummy"),
  original: el.category_image_original || selectIcon("userDummy"),
});

export const SetAnnouncementData = (el) => ({
  keyValue: "announcement_id",
  announcement_id: el.announcement_id || "",
  title: el.title || "",
  type: el.type || "",
  gym_id: el.gym_id || "",
  url: el.url || "",
  start_date: el.start_date || "",
  end_date: el.end_date || "",
  status: el.status || "",
  display_image_original_url: el.display_image_original_url || "",
  display_image_thumb_url: el.display_image_thumb_url || "",
  announcement_position: el.announcement_position,
  image: setImage(el.display_image_original_url, el.display_image_thumb_url),
  location_ids: el.location_ids || [],
  hide_title: el.hide_title || "",
});

const setImage = (original, thumb) => ({
  keyValue: "thumb",
  thumb: thumb,
  original: original,
});

export const setPlanList = (el) => ({
  name: el.name,
  description: el.description,
  created_by: el.created_by,
  created_at: el.created_at,
  updated_at: el.last_modified_at,
  visibility: el.visibility,
  total_purchase: el.total_purchase,
  stripe_product_id: el.stripe_product_id,
  status: el.status,
  id: el.plan_id,
  keyValue: "id",
  pricing_type: el.pricing_model,
  payment_option: el.billing_type,
  price: el.price || 0,
  expiry_interval_count: el.expiry_interval_count,
  expiry_interval: el.expiry_interval,
  recurring_interval_count: el.recurring_interval_count,
  recurring_interval: el.recurring_interval,
  free_trial_days: el.free_trial_days,
  free_trial_availability: el.free_trial_availability,
  location_ids: el.location_ids || [],
  locations: el.locations || [],
  editDisable: CheckValue(el.stripe_product_id),
  image: setImage(el.plan_image_original_url, el.plan_image_thumb_url),
});

export const setCouponList = (el) => {
  const amount_off = CheckValue(el.coupon.amount_off)
    ? el.coupon.amount_off / 100
    : 0;
  return {
    name: el.coupon.name,
    code: el.code,
    created_at: el.created * 1000,
    redeem_by: el.coupon.redeem_by,
    percent_off: el.coupon.percent_off,
    amount_off: amount_off,
    discount: `${CheckValue(el.coupon.amount_off) ? "$" : ""}${
      el.coupon.percent_off || amount_off || 0
    }${CheckValue(el.coupon.percent_off) ? "%" : ""}`,
    discountType: CheckValue(el.coupon.percent_off) ? "%" : "",
    status: el.active.toString(),
    times_redeemed: el.times_redeemed,
    id: el.id,
    keyValue: "id",
  };
};
export const setTransactionsList = (el) => {
  let data = {
    price: {
      recurring: null,
    },
  };
  if (CheckValue(el.lines.data) && el.lines.data.length) {
    data = el.lines.data[0];
  }
  let billing_frequencys = "One Time";
  if (CheckValue(data.price.recurring)) {
    billing_frequencys = "";
    let temp = billing_frequency.filter(
      (e) => e.backGroundData === data.price.recurring.interval
    );
    if (temp.length > 1 || data.price.recurring.count > 1) {
      billing_frequencys = "Every ";
      billing_frequencys += data.price.recurring.count + " ";
      billing_frequencys += temp[0].shortName + "s";
    } else {
      billing_frequencys = temp[0].name;
    }
  }
  let currencyFilter = {
    symbol: "$",
  };
  if (CheckValue(el.currency)) {
    const tempCurrencyFilter = currency.filter(
      (e) => e.value.toLowerCase() === el.currency
    );
    if (tempCurrencyFilter.length) {
      currencyFilter = tempCurrencyFilter[0];
    }
  }
  return {
    name:
      CheckValue(el.customer_name) && !el.customer_name.includes("undefined")
        ? el.customer_name
        : "---",
    email: CheckValue(el.customer_email) ? el.customer_email : "---",
    planName: el.metadata.plan_name, //
    user_id: el.metadata.user_id, //
    refund: CheckValue(el.metadata.refund)
      ? isBoolean(el.metadata.refund)
      : false, //
    purchased_at: el.created * 1000,
    amount: currencyFilter.symbol + " " + el.amount_paid / 100,
    invoice: el.invoice_pdf,
    payment_intent: el.payment_intent,
    billing_frequency: billing_frequencys,
    // card_number: el.billing_frequency, //
    id: el.id,
    keyValue: "id",
  };
};
export const setSubscriptionsList = (el) => {
  let billing_frequencys = paymentTypeOption[1].name;
  if (CheckValue(el.recurring_interval)) {
    billing_frequencys = "";
    if (el.recurring_interval_count > 1) {
      billing_frequencys = "Every ";
      billing_frequencys += el.recurring_interval_count + " ";
    }
    let temp = billing_frequency.filter(
      (e) => e.backGroundData === el.recurring_interval
    );
    if (temp.length) {
      billing_frequencys += temp[0].shortName;
    } else {
      billing_frequencys += el.recurring_interval;
    }
    if (el.recurring_interval_count > 1) {
      billing_frequencys += "s";
    }
  }

  let currencyFilter = {
    symbol: "$",
  };
  if (CheckValue(el.currency)) {
    const tempCurrencyFilter = currency.filter(
      (e) => e.value.toLowerCase() === el.currency
    );
    if (tempCurrencyFilter.length) {
      currencyFilter = tempCurrencyFilter[0];
    }
  }
  let payment_type = {
    name: el.billing_type,
    value: el.billing_type,
    info: "",
  };
  if (CheckValue(el.billing_type)) {
    const tempPayment_type = paymentTypeOption.filter(
      (e) => e.value === el.billing_type
    );
    if (tempPayment_type.length) {
      payment_type = tempPayment_type[0];
    }
  }
  let subscription_status = {
    name: el.subscription_status,
    value: el.subscription_status,
  };
  const temp = transactionStaus.filter(
    (e) => e.value === el.subscription_status
  );
  if (temp.length) {
    subscription_status = temp[0];
  }
  return {
    planName: el.name,
    payment_type: payment_type.name,
    billing_frequency: billing_frequencys,
    subscription_status: subscription_status,
    amount: currencyFilter.symbol + " " + Number(el.price),
    userData: "---",
    stripe_subscription_id: el.stripe_subscription_id,
    id: el.subscription_id,
    keyValue: "id",
  };
};
